import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://shahjalal-json-data.herokuapp.com",
});

export default axiosInstance;
